<script lang="ts" setup>
import { CompensationForm } from 'cesg-shared/dist/models/schemas/domain';
import { computed } from 'vue';
import SensitiveValuesSwitch from '../SensitiveValuesSwitch.vue';
import type { SensitiveViewMode } from '../SensitiveValuesSwitch.vue';
import { useSensitiveValuesSwitchQuery } from './query';

const props = defineProps<{
  projectId: string;
  mode: SensitiveViewMode;
}>();

const emit = defineEmits<{
  'update:mode': [value: SensitiveViewMode];
}>();

const { data } = useSensitiveValuesSwitchQuery(props.projectId);

const show = computed(
  () =>
    !data.query.isLoading.value &&
    data.query.data.value?.compensationForm === CompensationForm.FAST,
);
</script>

<template>
  <SensitiveValuesSwitch
    v-if="show"
    :mode="props.mode"
    @update:mode="emit('update:mode', $event)"
  />
</template>
